export const RECEIVE_EDUCATION_DATA = "RECEIVE_EDUCATION_DATA";
export const SHOW_LOADER = "SHOW_EDUCATION_LOADER";

export interface IEducationState {
    educationData?: EducationData[];
    isLoading: boolean;
}

export interface EducationData {
    title?: string;
    summary?: string;
    author?: string;
    feedUrl?: string;
    imageUrl?: string;
    publishDate?: string;
}

export interface GetEducationDataAction {
    type: "RECEIVE_EDUCATION_DATA";
    educationData: EducationData[];
}
export interface ShowAction {
    type: "SHOW_EDUCATION_LOADER";
    isLoading: boolean;
}

export type KnownAction = GetEducationDataAction | ShowAction;
